import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import ResetPassword from './routes/resetPassword';
import './static/css/style.css';
import Logo from './static/img/Multiverse_logo.png'
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import { clearUserData, setUserData } from './redux/MlReduxCalls/LocalDataReduxStore';
import 'antd/dist/antd.less';
import { getAxiosInstance } from './Api/ApiConfig';

const { theme } = config;

function ProviderConfig() {
  const [path, setPath] = useState(window.location.pathname);
  const [accessToApp, setAccessToApp] = useState(false);
  const { rtl, topMenu, darkMode } = useSelector((state) => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });
  const dispatch = useDispatch();
  async function getSessionAvaliability() {
    const expireToken = localStorage.getItem('Multiverse-Expire');
    if (expireToken) {
      const now = new Date().getTime();
      if (now >= parseInt(expireToken, 10)) {
        const formData = {}
        const response = await getAxiosInstance().post(`/usermgmt/logOut`, formData)
        if (response.data.statusCode === 200) {
          localStorage.removeItem('Multiverse-Expire');
          dispatch(clearUserData());
          setAccessToApp(false);
        }
      }
      else {
        const response = await getAxiosInstance().get(`/usermgmt/getUserProfileOrInternalUserByToken`)
        if (response.data.roleName) {
          dispatch(setUserData({
            MultiverseRole: response.data.roleName
          }));
          setAccessToApp(true);
        }
      }
    }
    else {
      localStorage.removeItem('Multiverse-Expire');
      dispatch(clearUserData());
      setAccessToApp(false);
    }
  }
  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    const currentPath = window.location.pathname;
    const isResetPasswordRoute = currentPath.includes('/dashboard/resetPassword');
    if (isResetPasswordRoute) {
      localStorage.removeItem('Multiverse-Expire');
      dispatch(clearUserData());
      setAccessToApp(true); // bypass session check for resetPassword route
    } else {
      getSessionAvaliability();
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath,]);
  const isResetPassword = path === "/dashboard/resetPassword";
  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          <Route path="/dashboard/resetPassword" component={ResetPassword} />
          {!isResetPassword && (
            <> {!accessToApp ? (<Route path="/" component={Auth} />) : (<ProtectedRoute path="/dashboard" component={Admin} />)}
              {accessToApp && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) ? (<Redirect to="/dashboard" />) :
                <Redirect to="/" />}
            </>
          )}
          {/* <Route render={() => <Redirect to={accessToApp ? "/dashboard" : "/"} />} /> */}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5', // Adjust background color as needed
  };
  return (
    <Provider store={store}>
      <div style={{ position: 'relative' }}>
        {loading && (
          <div style={loadingStyle}>
            <img src={Logo} alt="App Logo" style={{ width: '100px' }} />
          </div>
        )}
        <div style={{ display: loading ? 'none' : undefined }}>
          <ProviderConfig />
        </div>
      </div>
    </Provider>
  );
}

export default hot(App);
